export default __webpack_public_path__ + "static/media/connect-big-commerce2.7e34450e.jpeg";